import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# **Request-Level Documentation**

HawkClient makes it easy to document individual requests using **Markdown**.  
Each request has a dedicated **Docs** tab where you can describe the purpose, expected input/output, and any additional notes for the request.

This is useful for maintaining clarity when working on large APIs or collaborating with team members, ensuring every request is self-explanatory and well-documented.

![Request Documentation](/docs/RequestDoc.png)

To edit the documentation, click on the **Edit Mode** button as shown in the screenshot above.  
This opens a Markdown editor where you can update the request's description in real time.

![Request Documentation Edit Mode](/docs/RequestDocEdit.png)
`;

const RequestDocumentation = () => {
    return (
        <MarkDownRenderer
            title="Request Documentation"
            markDownText={markdownContent}
        />
    );
};

export default RequestDocumentation;
